import { color, query } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';

// Note: This component is set to 100% width, so add a wrapper with a width (not necessarily a height) to set the circle size

//
//
// Advisor Headshots

export interface AdvisorHeadshotProps {
  img: string;
  alt_text: string;
  dataTestId?: string;
}

export const AdvisorHeadshot: FC<AdvisorHeadshotProps> = ({ img, alt_text, dataTestId }) => {
  return (
    // if img is empty, then set setColorBg to true
    <AdvisorHeadshotsWrapper $setColorBg={!img}>
      {img && <img src={img} alt={alt_text} data-testid={dataTestId} />}
    </AdvisorHeadshotsWrapper>
  );
};

// Styling
const AdvisorHeadshotsWrapper = styled.span<{ $setColorBg: boolean }>`
  display: inline-block;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  box-sizing: border-box;
  // if setColorBg is true, then set the background-color to gray2
  background-color: ${() => color('gray2') && 'transparent'};
  overflow: visible;

  img {
    position: absolute;
    width: calc(100% - 2px); // account for border and box-shadow
    height: calc(100% - 2px);
    top: 1px;
    left: 1px;
    object-fit: cover;
    object-position: center;
    border: 3px solid transparent;
    box-shadow: 0 0 0 1px ${color('gray3')};
    border-radius: 50%;
    box-sizing: border-box;

    @media screen and (${query.atLeast('tablet')}) {
      border-width: 4px;
    }
  }
`;
